import Component from '@glimmer/component'
import type ReportingService from 'teacher-ui-client/services/reporting'
import { service } from '@ember/service'
import { Product } from 'teacher-ui-client/utils/products'
import { trackedFunction } from 'reactiveweb/function'
import { toRequestScopeStudent, type BaseReport } from 'teacher-ui-client/services/reporting'
import type { NormalizedInterval } from 'date-fns'
import type Student from 'teacher-ui-client/models/student'
import { keepLatest } from 'reactiveweb/keep-latest'
import { use } from 'ember-resources'
import { Report } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/overview/report'
import NoReportValue from 'teacher-ui-client/components/reporting/no-report-value'
import { array } from '@ember/helper'

export interface ReportData extends BaseReport {
  overview: {
    total_assignments_completed: number
    average_lexile_formatted: Nullable<string>
    lexile_range_formatted: Nullable<string>
  }
}

interface ReportLoaderSignature {
  Args: {
    period: NormalizedInterval
    student: Nullable<Student>
  }
}

export class ReportLoader extends Component<ReportLoaderSignature> {
  @service reporting!: ReportingService

  fetchReport = trackedFunction(this, async () => {
    if (!this.args.student?.id) return undefined

    const url = this.reporting.buildGravityUrl({
      product: Product.REX,
      requestScope: toRequestScopeStudent(this.args.student.id),
      reportName: 'student-dashboard/read-aloud-fluency/overview',
    })
    const query = this.reporting.buildQuery({
      period: this.args.period,
    })
    const report = await this.reporting.fetchReport<ReportData>(url, query)
    return report.overview.total_assignments_completed !== 0 ? report : null
  })

  @use
  latestReport = keepLatest({
    value: () => this.fetchReport.value,
    when: () => this.fetchReport.isPending,
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    {{#if this.latestReport}}
      <Report
        @isReloading={{this.fetchReport.isLoading}}
        @reportData={{this.latestReport}}
        @studentName={{@student.fullName}}
      />
    {{else}}
      <NoReportValue @reportStates={{array this.fetchReport}} />
    {{/if}}
  </template>
}
